<template>
  <!-- eslint-disable vue/require-component-is -->
  <div>
    <el-select
      v-model="defaultValue"
      placeholder="请选择日期"
      style="width:100%"
      @change="changeValue"
    >
      <el-option
        v-for="item in options"
        :key="item.data"
        :label="item.label"
        :value="item.data"
      />
    </el-select>
    <el-dialog
      title="自定义时间段"
      :visible.sync="dialogVisible"
      class="el-dialog-custom-date"
      append-to-body
    >
      <el-date-picker
        v-model="value1"
        size="mini"
        type="daterange"
        value-format="yyyy-MM-dd"
        range-separator=" - "
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        style="width: 95%; margin-left: 16px;"
      />
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click="confirmDate"
        >确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    searchDate: {
      required: true,
      default: '',
      type: String
    }
  },
  data () {
    return {
      dialogVisible: false,
      value1: '',
      options: [
        {
          data: 'all',
          label: '全部时间'
        },
        {
          data: 'userSetting',
          label: '自定义时间',
          type: 'userSetting'
        },
        {
          data: 'today',
          label: '今天'
        },
        {
          data: 'yesterday',
          label: '昨天'
        },
        {
          data: 'week',
          label: '本周'
        },
        {
          data: 'month',
          label: '本月'
        },
        {
          data: 'lastMonth',
          label: '上月'
        },
        {
          data: 'year',
          label: '本年'
        },
        {
          data: 'lastYear',
          label: '去年'
        }
      ]
    }
  },
  computed: {
    defaultValue: {
      get: function () { return this.searchDate },
      set: function (val) { this.changeValue(val) }
    }
  },
  methods: {
    changeValue (dateValue) {
      if (dateValue === this.options[1].data) {
        this.dialogVisible = true
      } else {
        this.$emit('update:searchDate', dateValue)
      }
    },
    confirmDate () {
      this.dialogVisible = false
      let dateRange = this.value1 ? this.value1.join(' 至 ') : ''
      this.defaultValue = dateRange
      this.options[1].label = dateRange
      this.$emit('update:searchDate', dateRange)
    }
  }
}
</script>
<style lang="scss" scoped>
.el-dialog-custom-date {
  width: 720px !important;
  margin: 0 auto !important;
}
</style>